import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import AssessmentActivity from 'components/AssessmentActivity';

const AssessmentByUuid: React.FC = () => {
    const { uuid } = useParams();

    if (!uuid) {
        return <Navigate to="/" replace />;
    }

    return <AssessmentActivity submissionUuid={uuid} />;
};

export default AssessmentByUuid;
